import type * as React from 'react';
import Modal from '../';
import { GENERAL } from '../../../intercom/intercom-data-targets';
import type { ButtonKind } from '../../Button';
import Button from '../../Button';
import { DeprecatedButtonContainer } from '../../ButtonContainer';
import type { ModalProps } from '../presenter';
import type { ModalSize } from '../sizes';
import styles from './style.m.less';

export interface ConfirmModalProps extends Omit<ModalProps, 'children' | 'className'> {
    confirmKind?: ButtonKind;
    onClose: () => void;
    onConfirm: () => void;
    onCancel?: () => void;
    confirmLabel?: React.ReactNode;
    cancelLabel?: React.ReactNode;
    body?: React.ReactNode;
    size?: ModalSize;
    noCloseIcon?: boolean;
    autoFocusConfirmButton?: boolean;
    disabled?: boolean;
}

export function ConfirmModal({
    confirmKind = 'PRIMARY',
    onClose,
    onConfirm,
    onCancel = () => {},
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    body,
    size = 'MD_WIDTH',
    noCloseIcon = true,
    autoFocusConfirmButton = true,
    disabled = false,
    ...otherModalProps
}: ConfirmModalProps) {
    return (
        <Modal
            {...otherModalProps}
            size={size}
            noCloseIcon={noCloseIcon}
            className={styles.container}
            onClose={onClose}
        >
            <div className={styles.body}>{body}</div>
            <DeprecatedButtonContainer className={styles.buttonContainer}>
                <Button
                    onClick={() => {
                        onCancel();
                        onClose();
                    }}
                    testId="close"
                >
                    {cancelLabel}
                </Button>
                <Button
                    kind={confirmKind}
                    disabled={disabled}
                    onClick={() => {
                        onConfirm();
                        onClose();
                    }}
                    autoFocus={autoFocusConfirmButton}
                    data-intercom-target={GENERAL.SHARE_BUTTON_CONFIRM_MODAL}
                    testId="confirm-ok"
                >
                    {confirmLabel}
                </Button>
            </DeprecatedButtonContainer>
        </Modal>
    );
}

export default ConfirmModal;
